<template>
  <div class="footer-contain">
    <!-- <h2>大洲玉文化创意园</h2> -->
    <img alt="" class="img-fluid-name" src="../assets/footer-text.png">
    <div class="numcontainer">
      <p class="textnum">
        <a class='linka' href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024087432号 </a>
        <a class='linka' href="https://beian.miit.gov.cn/" target="_blank">京ICP备2024087432号-2 </a>
        <img alt="" class="img-fluid" src="../assets/img/home/guohui.png">
        <a class='linka' target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202007632">京公网安备 11010202000018号</a>
      </p>    
      <p class="textnum">互联网新闻信息服务许可证10120170003 违法和不良信息举报电话：010-88047123</p>  
    </div>
  </div>
</template>

<script>

export default {
  name: 'CommonFooter',
  data() {
    return {
    }

  },
  methods: {

  },
  computed: {


  },
  mounted() {
    //加载


  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.footer-contain {
  // height: 11.7vw !important;   //
  min-height: 112px;
  min-width: 850px;
  background-color: #262626;
  align-items: center;
  margin: 0;
  padding: 40px;
  padding-bottom: 10px;
  text-align: center;
  color: #fff;

  .floot_icon {
    margin-right: 15px;
    width: 30px;
    height: 30px;
    filter: brightness(0.1); //设置图标为灰色
  }
}
.img-fluid-name {
    width: 100%;
    max-width: 1024px;
    height: auto;
}
.numcontainer{
  padding-top: 40px;
  // margin-bottom: 10px;
  text-align: left;
  .textnum{
    font-size: 10pt;
    margin-bottom: 2px;
  }
  .linka{
    color: white !important;
  }
  .linka:hover{
    color: rgb(238, 93, 93) !important;
  }
}
</style>
